import React, { useEffect, useState } from 'react';

import { Flex } from '@chakra-ui/react';
import { OneOnOneNotes } from 'screens/oneOnOneRabbit/interfaces/OneOnOneNotes';
import { z } from 'zod';

import { RichTextEditor2 } from 'uiToolkitV1/RichTextEditor2';
import { TextLabel } from 'uiToolkitV1/Typography';

type Props = {
  label?: string;
  onChange?: ({
    feedbackText,
    feedbackTextHtml,
    isPrivate,
  }: {
    feedbackText: string;
    feedbackTextHtml: string;
    isPrivate: boolean;
  }) => void;
  templateAgendaId?: number;
  p?: string;
  testId?: string;
};

type OneOnOneNotesProps = Props & z.infer<typeof OneOnOneNotes>;

const RichTextNote = ({ label, onChange, feedbackTextHtml, isPrivate, p, testId }: OneOnOneNotesProps) => {
  const [htmlText, setHtmlText] = useState<string>(feedbackTextHtml ?? '');

  const onBlur = (htmlText: string, plainText: string) => {
    setHtmlText(htmlText);
    onChange?.({
      feedbackText: plainText,
      feedbackTextHtml: htmlText,
      isPrivate,
    });
  };

  useEffect(() => {
    setHtmlText(feedbackTextHtml ?? '');
  }, [feedbackTextHtml]);

  return (
    <Flex
      sx={{
        '.character-count': {
          maxWidth: '100%',
        },
      }}
      p={p}
      flexDir="column"
    >
      <TextLabel mb="12px">{label}</TextLabel>
      <RichTextEditor2
        placeholder="Add meeting Notes"
        maxCharLimit={5000}
        onOutsideClick={onBlur}
        content={htmlText}
        editorMaxHeight="150px"
        showCharacterCount={false}
        testId={testId}
      />
    </Flex>
  );
};

export default RichTextNote;
